import { createLocationState } from "@rangojs/router";

export const FlashMessage = createLocationState<{ text: string; type?: "success" | "error" }>({
  flash: true,
});
